import React, { FC } from 'react';
import _ from 'lodash';
import { Heading } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import {
  getSeoSettingsForService,
  getSeoSettingsForCategory,
} from '../../../utils/constants';
import { useExploreContext } from '../../Contexts/ExploreContext';

type Props = {
  dataHook: string;
  isMobileView: boolean;
};

const PageTitle: FC<Props> = ({ dataHook, isMobileView }) => {
  const { t } = useTranslation();
  const {
    state: { category, service },
  } = useExploreContext();

  function renderPageTitle() {
    if (service) {
      const servicePathName = _.get(service, 'pathName');
      if (servicePathName) {
        const settings = getSeoSettingsForService(servicePathName);
        return t(settings.h1);
      }
    }
    if (!service && category && category.pathName) {
      const settings = getSeoSettingsForCategory(category.pathName);
      return t(settings.h1);
    }
    return t('explore-page-heading-multiple-services');
  }

  return (
    <Heading
      as="h1"
      size={isMobileView ? 'large' : 'extraLarge'}
      dataHook={dataHook}
    >
      {renderPageTitle()}
    </Heading>
  );
};

export default PageTitle;
